import * as R from 'ramda';

const clearAll = () => state => {
    const userClientId = state.user.selectedUserClientId;
    const notificationsLens = R.lensPath([
        'clients',
        userClientId,
        'notifications',
    ]);
    return R.set(notificationsLens, [], state);
};

export default clearAll;
